import "./GeodeticWorks.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInLongueuil from "./sections/PatioDoorRepairServicesInLongueuil";
import HeroSection from "./sections/HeroSection";
import ContactSection from "./sections/ContactSection";
import Footer from "@/reusable_sections/Footer";
import FinePrint from "./sections/FinePrint";
export default function GeodeticWorksPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInLongueuil />
      <HeroSection />
      <FinePrint />
      <ContactSection />
      <Footer />
    </div>;
}